import React, {createContext, useContext, useEffect, useState} from 'react';
import {getMenu} from "../app/common/api/WebApi";
import {CONSTANTS} from "../app/common/constants";
import {CompanyContext} from "./CompanyProvider";
import {getCookie} from "../app/common/appCookie";

export const MenuContext = createContext({
  menuItems: [],
  refreshContext: true
});


export const MenuProvider = (props) => {
  const [context, setContext] = useState({
    menuItems:[],
    refreshContext: true
  });

  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const navItemText = (_navItem, _menuItems) => {
    let navItem = {..._navItem};
    for (let j in _menuItems) {
      if (_menuItems[j].itemKey === navItem.itemKey) {
        let item = _menuItems[j];
        if (item.name) {
          navItem.name = item.name;
        }
        if (item.sortOrder) {
          navItem.sortOrder = item.sortOrder;
        }
        if (item.hidden) {
          navItem.hidden = item.hidden;
        }
      }
    }
    return navItem;
  }

  const configureMenuItems = (resp) =>{
    let items = [...resp];
    let _items = [];
    for (let j in items) {
      let _item = navItemText(items[j], CONSTANTS.SITE_OPTIONS?.menu?.items || []);
      if (!_item.hidden) {
        _items.push(_item);
      }
    }
    return _items;
  }

  const [refreshLocal, setRefreshLocal]= useState(1);

  useEffect(() => {
    if (context.refreshContext || (refreshLocal && refreshLocal < 25)) {
      if (!getCookie(CONSTANTS.PSB_CID)?.length) {
        const timer = setTimeout(() => {
          setRefreshLocal(refreshLocal + 1)
        }, 1000);
        // Cleanup function to clear the timeout when the component unmounts
        return () => clearTimeout(timer);
        return;
      }
      getMenu().then(resp => {
        let _c = {...context};
        _c.refreshContext = false;
        _c.menuItems = configureMenuItems(resp);
        setContext({..._c});
      });
    }
  }, [context.refreshContext, refreshLocal]);

  return (
    <MenuContext.Provider value={[context, setContext]}>
      {props.children}
    </MenuContext.Provider>
  )
}